import {
  useGenerateRelatedMutation,
  useInsertEntityReferencesMutation,
} from '@crew/apis/entityReference/entityReferenceApis'
import { EntityReferenceType, EntityType } from '@crew/enums/domain'
import { EntityReference } from '@crew/models/domain'
import { NotifyEventType } from 'enums/app'
import {
  ObjectEventMessage,
  notifyEntityReferencesEvent,
} from 'features/app/states/appSlice'
import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from 'states/hooks'
import { SuggestionItem } from '../../taskDetailRelatedInfoList'

export const useTaskDetailRelatedInfoListToolbar = () => {
  const dispatch = useAppDispatch()
  const { taskId } = useParams()

  // タスク関連情報生成API
  const [
    generateRelatedMutation,
    { isLoading: isLoadingGenerateRelatedMutation },
  ] = useGenerateRelatedMutation()
  // エンティティ参照登録API
  const [
    insertEntityReferencesMutaion,
    { isLoading: isLoadingInsertEntityReferencesMutaion },
  ] = useInsertEntityReferencesMutation()

  // 関連提案生成
  const generateTaskRelatedInfo = useCallback(async () => {
    if (!taskId) {
      throw new Error('taskId is undefined')
    }

    await generateRelatedMutation({
      entityType: EntityType.Task,
      entityRecordId: taskId,
    }).unwrap()
  }, [generateRelatedMutation, taskId])

  // 関連情報登録
  const insertEntityReferences = useCallback(
    async (data: SuggestionItem[]) => {
      if (data.length === 0) {
        return
      }

      await insertEntityReferencesMutaion({
        referenceType: EntityReferenceType.RelatedTasks,
        sourceEntityType: EntityType.Task,
        sourceEntityRecordId: taskId ?? '',
        destinationEntityReferences: data,
      }).unwrap()

      const objectEventMessage: ObjectEventMessage<EntityReference> = {
        eventType: NotifyEventType.Inserted,
        id: '',
        object: undefined,
      }
      dispatch(notifyEntityReferencesEvent(objectEventMessage))
    },
    [dispatch, insertEntityReferencesMutaion, taskId]
  )

  return {
    insertEntityReferences,
    isLoadingInsertEntityReferencesMutaion,
    generateTaskRelatedInfo,
    isLoadingGenerateRelatedMutation,
  }
}
